import React, { createContext, ReactNode, useContext, useState } from 'react'

interface KeyProtectionContextType {
  isProtected: boolean
  enableProtection: () => void
  disableProtection: () => void
  onKeysCopied: () => void
}

const KeyProtectionContext = createContext<KeyProtectionContextType | undefined>(undefined)

interface KeyProtectionProviderProps {
  children: ReactNode
}

export const KeyProtectionProvider: React.FC<KeyProtectionProviderProps> = ({ children }) => {
  const [isProtected, setIsProtected] = useState(false)
  // const [hasCopiedKeys, setHasCopiedKeys] = useState(false)

  const enableProtection = () => {
    setIsProtected(true)
    // setHasCopiedKeys(false)
  }

  const disableProtection = () => {
    setIsProtected(false)
    // setHasCopiedKeys(false)
  }

  const onKeysCopied = () => {
    // setHasCopiedKeys(true)
    disableProtection()
  }

  const value: KeyProtectionContextType = {
    isProtected,
    enableProtection,
    disableProtection,
    onKeysCopied,
  }

  return <KeyProtectionContext.Provider value={value}>{children}</KeyProtectionContext.Provider>
}

export const useKeyProtectionContext = (): KeyProtectionContextType => {
  const context = useContext(KeyProtectionContext)

  if (context === undefined) {
    throw new Error('useKeyProtectionContext must be used within a KeyProtectionProvider')
  }

  return context
}
